export default __webpack_public_path__ + "static/media/custom3.b3883d5c.jpg";